import React from 'react';

/**
 * 全局错误边界 — 防止页面崩溃时白屏
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 40,
          textAlign: 'center',
          background: '#FFF9F2',
          fontFamily: 'system-ui, sans-serif',
        }}>
          <div style={{ fontSize: 64, marginBottom: 20 }}>🩹</div>
          <h1 style={{ color: '#B45A3A', marginBottom: 12 }}>页面出了点小问题</h1>
          <p style={{ color: '#7E5A4A', marginBottom: 24 }}>
            抱歉，页面加载遇到了意外错误。<br />
            请尝试刷新页面，或联系客服。
          </p>
          <button
            onClick={() => window.location.reload()}
            style={{
              background: '#E6B08C',
              color: 'white',
              border: 'none',
              padding: '12px 32px',
              borderRadius: 40,
              fontSize: 16,
              cursor: 'pointer',
              fontWeight: 600,
            }}
          >
            🔄 刷新页面
          </button>
          <div style={{ marginTop: 32 }}>
            <a href="/" style={{ color: '#C97B5A', textDecoration: 'none' }}>
              🏠 返回首页
            </a>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
